import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import SurveyCreateLinkIcon from "../../common/icons/SurveyCreateLinkIcon";
import {RightSidebarActionButton} from "../../layout/rightSidebar/RightSidebarRail";
import SurveyInviteDialog from "./SurveyInviteDialog";

export default function SurveyInviteRailButton() {
    const {t} = useTranslation();
    const readOnly = useReadOnly();
    const [open, setOpen] = useState(false);

    return (
        <>
            <RightSidebarActionButton
                icon={<SurveyCreateLinkIcon/>}
                label={t("Create survey link")}
                disabled={readOnly}
                onClick={() => setOpen(true)}
            />
            {/* Remount so every opening starts with a fresh guest and survey selection. */}
            {open && <SurveyInviteDialog open onClose={() => setOpen(false)}/>}
        </>
    );
}
